<template>
  <main class="home" :class="{active: showAbout}">
    <div id="about">
      <div class="about_back" @click="test">Close</div>
      <div class="about_inner" v-html="about.markdown.contact_md"/>
    </div>
    <div class="title">
      <h1 class="pj-title" @click="test">{{ site.title }}</h1>
    </div>

    <div class="slideshow">
      <swiper :options="swiperOption">
       <swiper-slide
       class="pj-image"
       v-for="img in projects.children[0].files"
       :key="img.id">
         <img :data-src="img.url" class="swiper-lazy">
       </swiper-slide>
      </swiper>

      <!-- <div
      class="pj-image"
      v-for="(img, index) in projects.children[0].files"
      :key="img.id"
      :class="{ 'active': index == sI }"
      @click.prevent="nextSlide"
      >
        <img :src="img.url" alt="">
        <! <v-lazy-image
          :src="img.url"
          :src-placeholder="img.thumb"
        />
          :style="{ 'object-position': img.focusX + '% ' + img.focusY + '%' }"
      </div> -->
    </div>
  </main>
</template>

<script>
export default {
  data() {
    return {
      pI: 0,
      sI: 0,
      nI: 0,
      tI: 0,
      showAbout: false,
      swiperOption: {
        slidesPerView: 1,
        speed: 0,
        // effect: 'fade',
        lazy: true,
        loop: true,
        navigation: {
          nextEl: '.pj-image',
        },
      }
    }
  },
  computed: {
    site() {
      return this.$store.state.site
    },
    projects() {
      return this.$store.getters.getPageByUID('projects')
    },
    about() {
      return this.$store.getters.getPageByUID('about')
    }
  },
  mounted: function () {
    this.tI = this.projects.children[0].files.length
  },
  methods: {
    test() {
      this.showAbout = !this.showAbout
    },
    nextSlide() {
      if(this.sI == (this.tI - 1)) {
        this.sI = 0;
      } else {
        this.sI++
      }
    }
  }
}
</script>

<style lang="scss" scoped>
main {
  position: fixed;
  transition: margin-top .5s ease;
  width:100%;
  margin-top:calc(-100vh + 1em);
  &.active {
    margin-top:0;
    .slideshow {
      opacity:0;
    }
  }
}
#about {
  height:calc(100vh - 2em);
  font-size:0.5em;
  overflow:auto;
  padding:1em;
  text-align: center;
  display:flex;
  flex-direction:column;
  justify-content: center;
  @media only screen and (max-width: 770px) {
    padding:0.5em;
  }
  .about_back {
    font-size:0.7em;
    position:absolute;
    top:1em;
    left:50%;
    transform: translate(-50%,0);
    cursor:pointer;
    &:hover {
      color:rgba(0,0,0,0.5);
    }
  }
  .about_inner {
    font-size:0.7em;
    p {
      margin-bottom:1em;
    }
  }
}
.title {
  width:100%;
  height:2em;
  font-size:0.5em;
  background:white;
  display:flex;
  justify-content: center;
  align-items: center;
  h1 {
    font-size:0.7em;
    margin:0;
    word-break: keep-all;
    white-space: nowrap;
    text-align:center;
    cursor:pointer;
    &:hover {
      color:rgba(0,0,0,0.5);
    }
  }
}
.slideshow {
  position:relative;
  height:calc(100vh - 1em);
  padding-bottom:1em;
  transition: opacity .5s;
  cursor:pointer;
  .pj-image {
    cursor:pointer;
    img {
      padding:0 1em;
      width:calc(100vw);
      height:calc(100vh - 2em);
      object-fit: contain;
      object-position: center center;
      @media only screen and (max-width: 770px) {
        padding:0 .5em;
      }
    }
    img {
    display: none;
    }
    img[src] {
     display: block;
    }

    // img[src=""] { display: none; }
  }
}

</style>
